import Component from '../core/Component'

export default class NavOpener extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()
        event.stopPropagation()

        const navElement = document.getElementById('nav')

        if (!navElement) {
            return
        }

        const nav = Component.getFromElement(navElement)

        if (nav) {
            nav.open()
        }
    }

}